import isEmpty from 'lodash/isEmpty'

// one case-normalizing membership rule for the grid and the filter checkboxes:
// a non-empty allow-list keeps only listed keys, then the deny-list drops its keys
/** Builds a member-key check from a filter's allow- and deny-lists, lower-casing each list once. */
export const createPivotMemberMatcher = ({
  includedValues,
  excludedValues,
}: {
  includedValues?: string[]
  excludedValues?: string[]
}): ((memberKey: string) => boolean) => {
  const included = new Set((includedValues ?? []).map((value) => value.toLowerCase()))
  const excluded = new Set((excludedValues ?? []).map((value) => value.toLowerCase()))
  // decided once here, not per member key — the matcher runs on every source row
  const restrictsToIncluded = !isEmpty(included)
  return (memberKey) => {
    const key = memberKey.toLowerCase()
    if (restrictsToIncluded && !included.has(key)) return false
    return !excluded.has(key)
  }
}
